export const positionlist  = [
  {
    label: 'Default',
    value: '',
  },		
  {
    label: 'Static',
    value: 'static',
  },		
  {
    label: 'Relative',
    value: 'relative',
  },	
  {
    label: 'Fixed',
    value: 'fixed',
  },			
  {
    label: 'Absolute',
    value: 'absolute',
  },	
  {
    label: 'Absolute Middle',
    value: 'absolute-middle',
  },					
  {
    label: 'Sticky',
    value: 'sticky',
  }														
]